<template>
    <div class="AiForecastingRecommendationEngine">
        <navbarv2 />
		<header class="header">
			<!-- <img src="../../assets/images/homepage/banner3.jpg" class="desktop-img"> -->
			<section class="banner-img-text">
                <h1 class="banner-title">AI Powered Forecasting and Recommendation Engine</h1>
                <div class="sub-text">Proprietary promotion forecasting and recommendation studies demand elasticity at an individual SKU, store and allows team to carefully plan promotions to meet their promotion KPIs</div>
			</section>
		</header>

        <div class="mb-8">
            <div class="section-title">
                What you can do with AI Powered Forecasting
            </div>

            <div class="product-details-section">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="product-details-col">
                            <div class="product-icon">
                                <img src="../../assets/images/products/planning.png">
                            </div>
                            <div>
                                <h4 class="product-title">Study Impact at Each Store and SKU level</h4>
                                <div class="product-details">
                                    Accurately understand how a promotion may impact at an individual store and SKU level allowing store operations and supply chain to execute promotions better
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="product-details-col">
                            <div class="product-icon">
                                <img src="../../assets/images/products/promotions.png">
                            </div>
                            <div>
                                <h4 class="product-title">Promotion Recommendation</h4>
                                <div class="product-details">
                                    Tool tracks your sales at a real time basis and based on pre-set triggers not only alerts the users on any possible sales slippages or impending expiry but suggests possible offers/discounts to achieve target sales
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 40px;" :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="product-details-col">
                            <div class="product-icon">
                                <img src="../../assets/images/products/customer.png">
                            </div>
                            <div>
                                <h4 class="product-title">Automated Customer Engagement</h4>
                                <div class="product-details">
                                    End to end engagement solutions allows marketing and operations team to reach out to target audience instantaneously; resulting in faster execution of campaign
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="product-details-col">
                            <div class="product-icon">
                                <img src="../../assets/images/products/improve.png">
                            </div>
                            <div>
                                <h4 class="product-title">Continuous Improvement Model</h4>
                                <div class="product-details">
                                    AI models continuously study sales, impact of promotions and improve predictions
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <requestDemo></requestDemo>
        <footerbar />
    </div>
</template>
<script>
import RequestDemoBar from '../../components/requestDemoBar/RequestDemoBar.vue';

export default {
    name: 'AiForecastingRecommendationEngine',
    components: {
        'requestDemo': RequestDemoBar
    },
    metaInfo() {
        return {
            title: 'AI Powered Forecasting and Recommendation Engine',
            titleTemplate: '%s - NymbleUp',
            htmlAttrs: {
              lang: 'en',
              amp: true
            },
            meta: [
              {
                vmid: 'title',
                name: 'title',
                content: 'AI Powered Forecasting and Recommendation Engine - NymbleUp'
              },
              {
                vmid: 'description',
                name: 'description',
                content: 'Nymbleup is one of the AI-powered forecasting platforms that is designed for the retail industry. Reduce error and improve forecasts in supply chain networks.'
              }
            ]
        }
    },
}
</script>
<style lang="scss" scoped>
.AiForecastingRecommendationEngine {
    .header {
        position: relative;
        width: 100%;
        background: #E29D5A;
        // background: linear-gradient(#fee7ac 0%, #E29D5A 95.02%, #E29D5A 100%, #fee7ac 100%, #E29D5A 100%);
        // background: linear-gradient(#5a66fa 0%, #212975 95.02%, #1e266e 100%, #1d266c 100%, #1e266e 100%);
        // background-image: url('../../assets/images/homepage/banner.jpg');
        // background-repeat: no-repeat;
        // background-size: cover;
        // background: black;
        text-align: center;
        height: 85vh!important;
        overflow: hidden;
        .banner-img-text{
            height: 100%;
            position: absolute;
            top: 40%;
            left: 0;
            right: 0;
            padding: 0 10px;
            .banner-title{
                color: #fff;
                line-height: 1.5;
            }
            .sub-text{
                font-size: 1rem;
                color: #fff;
                max-width: 550px;
                margin: 10px auto;
                line-height: 1.5;
            }
        }
    }

    .section-title{
        font-size: 22px;
        font-weight: 500;
        text-align: center;
        margin: 40px 0 60px 0;
        position: relative;
    }

    .section-title::after{
        position: absolute;
        bottom: -28px;
        left: 50%;
        width: 40px;
        height: 1px;
        margin-bottom: 15px;
        content: "";
        transform: translateX(-50%);
        background-color: #E29D5A;
    }

    .product-details-section{
        padding: 0 100px;
        .product-details-col{
            margin: 20px 0;
            display: flex;
            justify-content: center;
            .product-icon{
                width: 60px;
                height: 60px;
                min-width: 60px;
                // #d2d4e1
                background: rgba(253,207,90,0.5);
                display: -webkit-flex;
                display: -webkit-box;
                display: -moz-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin-right: 20px;
                img{
                    max-width: 35px;
                }
            }
            .product-title{
                font-size: 15px;
                color: #E29D5A;
            }
            .product-details{
                margin-top: 12px;
                font-size: 0.9rem;
                color: #000;
                line-height: 1.5;
                max-width: 400px;
            }
        }
    }
    @media screen and (max-width: 992px) {
        .product-details-section{
            padding: 0 10px;
        }
    }
}
</style>
